module.exports = __webpack_public_path__ + "static/media/dynamicscrm.bd2331d6.png";